import InnerRoute from './InnerRoute'
import { InnerRouterProvider, useInnerRouter } from './Provider'

type IInnerRouter = typeof InnerRouterProvider & {
  Route: typeof InnerRoute
  useInnerRouter: typeof useInnerRouter
}

const InnerRouter = InnerRouterProvider as IInnerRouter
InnerRouter.Route = InnerRoute
InnerRouter.useInnerRouter = useInnerRouter

export default InnerRouter
